// Internal modules
import { getToken } from '@/lib/globals';
import { appStore } from '@/store';
import { apolloClient } from '@/lib/apollo';
import { ADDRESS_AUTOCOMPLETE_FROM_POSTAL_CODE_QUERY } from '../graphql';

const fetchAddressesFromPostalCode = ({ addressType, country }) => {
  const { form } = appStore.getState();
  const postalCode = form[addressType]?.postalCode.value;
  const token = getToken();
  return apolloClient.query({
    query: ADDRESS_AUTOCOMPLETE_FROM_POSTAL_CODE_QUERY,
    variables: {
      country,
      postalCode,
      token,
    },
  });
};

export { fetchAddressesFromPostalCode };
